<div class="content">
  <div class="alert-wrapper">
    <glxy-alert type="tip">
      {{ tipTranslationKey | translate }}
    </glxy-alert>
  </div>

  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.GET_ASSOCIATED_CRM_OBJECT.SEARCH_CRITERIA' | translate }}
    </glxy-label>
    <mat-select [formControl]="optionsFormControl" [compareWith]="compareOptions">
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</div>
